import * as DB from "@/api/studentLeave.js"
import { request as Require } from "@/utils/require.js"
import { Toast } from "vant"

const state = () => ({
    backupData: {
        processAddIndex: 0,
        studentInfo: {},
        leaveType: {},
        leaveTypeName: '',
        startDateTime: '',
        endDateTime: '',
        approveInfo: {},
        remark: '',
        fileList: []
    },
    approvalResult: {}
});

const mutations = {
    setBackupData(state, payload) {
        state.backupData = payload
    },
    resetBackupData(state, payload) {
        state.backupData = payload || {
            processAddIndex: 0,
            studentInfo: {},
            leaveType: {},
            leaveTypeName: '',
            startDateTime: '',
            endDateTime: '',
            approveInfo: {},
            remark: '',
            fileList: []
        }
    }
};

const actions = {

    // 添加学生请假申请
    async addApply(context, params) {
        const r = await Require({
            api: DB.addApply,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取学生请假申请信息
    async applyInfo(context, params) {
        if (!params.id) {
            Toast.fail('缺少参数id')
            return
        }
        const r = await Require({
            api: Object.assign({}, DB.applyInfo, {
                url: DB.applyInfo.url + `/${params.id}`,
            }),
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // // 获取学生请假记录列表 ${id}
    // async messageList(context, params) {
    //     if (params.id) {
    //         DB.messageList.url = DB.messageList.url + `/${params.id}`
    //     } else {
    //         Toast.fail('缺少参数id')
    //         return
    //     }

    //     const r = await Require({
    //         api: DB.messageList,
    //         params,
    //     })
    //     if (r.success) {
    //         return {
    //             success: r.success,
    //             data: r.data,
    //             message: r.message,
    //         }
    //     } else {
    //         Toast.fail(r.message)
    //     }
    // },

    // 获取申请记录列表 (家长端)
    async applyListParent(context, params) {
        const r = await Require({
            api: DB.applyListParent,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
     // 获取申请记录列表 (老师端)
     async studentLeaveClassRecord(context, params) {
        const r = await Require({
            api: DB.studentLeaveClassRecord,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },


    // 获取学生请假申请状态列表
    async statusList(context, params) {
        const r = await Require({
            api: DB.statusList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 学生请假记录信息下载
    async exportApply(context, params) {
        const r = await Require({
            api: DB.exportApply,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 与我相关信息下载
    async exportMyRelated(context, params) {
        const r = await Require({
            api: DB.exportMyRelated,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 学生请假销假
    async finishApply(context, params) {
        const r = await Require({
            api: DB.finishApply,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取学生请假与我相关列表
    async myRelatedList(context, params) {
        const r = await Require({
            api: DB.myRelatedList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 撤销学生请假申请
    async leaveRevokeApply(context, params) {
        if (!params.id) {
            Toast.fail('缺少参数id')
            return
        }
        const r = await Require({
            api: Object.assign({}, DB.leaveRevokeApply, {
                url: DB.leaveRevokeApply.url + `/${params.id}`,
            }),
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 保存学生请假审批结果
    async approveResult(context, params) {
        const r = await Require({
            api: DB.approveResult,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取学生请假类型信息
    async leaveTypeList(context, params) {
        const r = await Require({
            api: DB.leaveTypeList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 获取符合条件的审批流信息
    async workflowCondition(context, params) {
        const r = await Require({
            api: DB.workflowCondition,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 获取记录的审批流详情信息
    async workflowRecordInfo(context, params) {
        const r = await Require({
            api: DB.workflowRecordInfo,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取当前审批人是否需要指定下级审批人
    async approverInfo(context, params) {
        const r = await Require({
            api: DB.approverInfo,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

      // 获取验证码
      async commonsmscaptcha(context, params) {
        const r = await Require({
            api: DB.commonsmscaptcha,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}